import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText, InspectorControls } from '@wordpress/blockEditor';
import { PanelBody, ToggleControl, ColorPalette, BaseControl, RangeControl, TextControl } from '@wordpress/components';

export default function Edit({ attributes, setAttributes }) {
    const { 
        blocCouleurFond, 
        blocCouleurBordure,
        id_accordeon_item_titre_texteTexte,
        id_accordeon_item_titre_texteCouleurTexte,
        id_accordeon_item_titre_texteOpacite,
        id_accordeon_item_bloc_paragraphe_texteTexte,
        id_accordeon_item_bloc_paragraphe_texteCouleurTexte,
        id_accordeon_item_bloc_paragraphe_texteOpacite,
        id_accordeon_item_bloc_paragraphe_texteAfficher,
        animCode
    } = attributes;

    const blockProps = useBlockProps({
        className: 'accordion-item',
        style: {
            backgroundColor: blocCouleurFond,
            borderColor: blocCouleurBordure
        }
    });

    return (
        <>
            <InspectorControls>
                <PanelBody title="Style du sous-bloc" initialOpen={true}>
                    <BaseControl label="Couleur de fond">
                        <ColorPalette
                            value={blocCouleurFond}
                            onChange={(val) => setAttributes({ blocCouleurFond: val })}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette
                            value={blocCouleurBordure}
                            onChange={(val) => setAttributes({ blocCouleurBordure: val })}
                        />
                    </BaseControl>
                </PanelBody>

                <PanelBody title="Titre de l'accordéon" initialOpen={true}>
                    <TextControl
                        label="Texte du titre"
                        value={id_accordeon_item_titre_texteTexte}
                        onChange={(val) => setAttributes({ id_accordeon_item_titre_texteTexte: val })}
                    />
                    <BaseControl label="Couleur du texte du titre">
                        <ColorPalette
                            value={id_accordeon_item_titre_texteCouleurTexte}
                            onChange={(val) => setAttributes({ id_accordeon_item_titre_texteCouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité du titre"
                        value={id_accordeon_item_titre_texteOpacite}
                        onChange={(val) => setAttributes({ id_accordeon_item_titre_texteOpacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>

                <PanelBody title="Contenu de l'accordéon" initialOpen={true}>
                    <ToggleControl
                        label="Afficher le contenu"
                        checked={id_accordeon_item_bloc_paragraphe_texteAfficher}
                        onChange={(val) => setAttributes({ id_accordeon_item_bloc_paragraphe_texteAfficher: val })}
                    />
                    <TextControl
                        label="Texte du contenu"
                        value={id_accordeon_item_bloc_paragraphe_texteTexte}
                        onChange={(val) => setAttributes({ id_accordeon_item_bloc_paragraphe_texteTexte: val })}
                    />
                    <BaseControl label="Couleur du texte du contenu">
                        <ColorPalette
                            value={id_accordeon_item_bloc_paragraphe_texteCouleurTexte}
                            onChange={(val) => setAttributes({ id_accordeon_item_bloc_paragraphe_texteCouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité du contenu"
                        value={id_accordeon_item_bloc_paragraphe_texteOpacite}
                        onChange={(val) => setAttributes({ id_accordeon_item_bloc_paragraphe_texteOpacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
            </InspectorControls>

            <div {...blockProps}>
                <div className="accordion-header">
                    <div className="accordion-button" style={{ backgroundColor: blocCouleurFond }}>
                        <RichText
                            tagName="span"
                            value={id_accordeon_item_titre_texteTexte}
                            onChange={(value) => setAttributes({ id_accordeon_item_titre_texteTexte: value })}
                            placeholder="Titre de l'item..."
                            style={{ color: id_accordeon_item_titre_texteCouleurTexte, opacity: id_accordeon_item_titre_texteOpacite }}
                        />
                        <svg width="16" height="16" fill="currentColor" style={{ marginLeft: 'auto' }}>
                            <path d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                        </svg>
                    </div>
                </div>
                <div className="accordion-collapse show">
                    <div className="accordion-body">
                        <RichText
                            tagName="p"
                            value={id_accordeon_item_bloc_paragraphe_texteTexte}
                            onChange={(value) => setAttributes({ id_accordeon_item_bloc_paragraphe_texteTexte: value })}
                            placeholder="Contenu du bloc..."
                            style={{ color: id_accordeon_item_bloc_paragraphe_texteCouleurTexte, opacity: id_accordeon_item_bloc_paragraphe_texteOpacite }}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}